import { CheckboxInput, FormItem, SubmitButton } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { LinkButton } from '@framework/ui';
import { Typography } from 'antd';
import { useWatch } from 'react-hook-form';
import { CitizenNationality } from '../../../routes/login/schema/CitizenRegisterSchema';
import { UserAccountForm } from './UserAccountForm';
import { UserNationalityForm } from './UserNationalityForm';
import { UserProfileFieldsForm } from './UserProfileFieldsForm';

const { Title } = Typography;

export interface IUserRegistrationFormProps {}

export function UserRegistrationForm(props: IUserRegistrationFormProps) {
  const nationality = useWatch({ name: 'nationality' });
  const { t } = useTranslation();

  const isExtraUeCitizen = nationality === CitizenNationality.ExtraEU;
  const isUeCitizen =
    nationality === CitizenNationality.EU ||
    nationality === CitizenNationality.Italy;

  return (
    <>
      <UserNationalityForm />
      {isUeCitizen && (
        <>
          <Title level={4}>
            {t(
              'user-registration.ue-citizen-message',
              'Sei un cittadino italiano o UE? Effettua il login con SPID/CIE o eIDAS.',
            )}
          </Title>
          <LinkButton to="/login" type="primary">
            {t('user-registration.back-to-login', 'Ritorna al login')}
          </LinkButton>
        </>
      )}
      {isExtraUeCitizen && (
        <>
          {/* Form Utente */}
          <UserAccountForm />

          {/* Anagrafica cittadino */}
          <UserProfileFieldsForm />

          <FormItem
            label={t('user-registration.form.privacy-acceptance', 'Consenso')}
            name="privacyAcceptance"
          >
            <CheckboxInput name="privacyAcceptance">
              <span>
                {t(
                  'user.registration.form.privacy-acceptance-text',
                  'Acconsento al trattamento dei dati personali',
                )}
              </span>
            </CheckboxInput>
          </FormItem>

          <SubmitButton style={{ width: '100%' }}>
            {t('user-registration.form.submit-button', 'Registrati')}
          </SubmitButton>
        </>
      )}
    </>
  );
}
